<template>
  <section class="signin-page">
    <!-- <b-loading is-full-page :active="loading" :can-cancel="false"></b-loading> -->
    <div class="mb-8">
      <img src="~/assets/images/signin-logo.svg" />
    </div>
    <template v-if="error">
      <h3 class="signin-page__error-message">
        Sorry, we could not find this email & password combination.
        <br />Please check your login information and try again!
      </h3>
      <br />
      <br />
    </template>
    <FieldGroup label="Email or Mobile">
      <template #field>
        <TextInput
          fieldGroup
          autofocus
          name="email"
          :value="email"
          :onChange="handleInputChange"
          :onEnterKey="handleLogin"
        ></TextInput>
      </template>
    </FieldGroup>
    <FieldGroup label="Password" iconRight="eye-outline">
      <template #field>
        <TextInput
          fieldGroup
          name="password"
          :value="password"
          :type="showPassword ? 'text' : 'password'"
          :onChange="handleInputChange"
          :onEnterKey="handleLogin"
        ></TextInput>
      </template>
      <template #icon-right>
        <span @click="handleShowPassword">
          <b-icon size="is-small" :icon="showPassword ? 'eye-off' : 'eye-outline'"></b-icon>
        </span>
      </template>
    </FieldGroup>
    <div style="width: 100%">
      <p class="has-text-right" style="position: relative; top: -20px">
        <a class="link-forgot-password" :href="forgotPasswordHref">Forgot Password?</a>
      </p>
      <BaseButton
        variant="filled"
        buttonClass="SignIn__SignInButton w-full justify-center bg-gradient-to-r from-[#00B8EC] to-[#61DFFA] font-700 text-18 h-48px"
        :size="40"
        :rounded="false"
        :loading="loading"
        :disabled="loading"
        @click="handleLogin"
        >SIGN IN</BaseButton
      >
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import { omit } from 'lodash'
import { USER_ROLES } from '~/global/data/roles'
import TextInput from '~/components/common/Form/TextInput'
import FieldGroup from '~/components/common/Form/FieldGroup'
import BaseButton from '~/components/v2/Inputs/BaseButton.vue'

export default {
  components: {
    TextInput,
    FieldGroup,
    BaseButton,
  },
  layout: 'authenticate',
  permissions: [USER_ROLES.ALL],
  data() {
    return {
      email: '',
      password: '',
      forgotPasswordHref: `${process.env.NUXT_ENV_LITTLELIVES_ENDPOINT}/signin/forgot-password`,
      showPassword: false,
      loading: false,
      error: false,
    }
  },
  methods: {
    handleInputChange(event) {
      const fieldName = event.target.name
      const fieldValue = event.target.value
      this[fieldName] = fieldValue
    },
    handleShowPassword() {
      this.showPassword = !this.showPassword
    },
    async handleLogin() {
      this.$cookie.remove('schoolId')
      try {
        this.loading = true

        const sanitizedEmail = this.sanitizedInput(this.email)
        const sanitizedPassword = this.sanitizedInput(this.password)

        const params = {
          identity: sanitizedEmail,
          password: sanitizedPassword,
          identity_type: 'email',
        }

        this.$errorProcessor.addTracingInfo({
          message: 'handleLogin',
          data: {
            identity: this.email,
          },
        })

        const response = await axios.post(`${process.env.NUXT_ENV_ACADEMY_AUTH_ENDPOINT}/session`, params, {
          headers: { 'Content-Type': 'application/json' },
        })

        if (response?.data?.access_token) {
          const { data } = response
          this.$cookie.set('laRefreshToken', data.refresh_token)
          await this.$apolloHelpers.onLogin(data.access_token, undefined)
          this.loading = false
          const { from } = this.$route.query
          const redirectLink = from && from !== 'signin' ? from : 'academy'
          const combineQueryString = Object.entries({ ...omit(this.$route.query, ['from']) }).reduce(
            (acc, arrayObjectValue) => {
              return (acc += `${arrayObjectValue[0]}=${arrayObjectValue[1]}&`)
            },
            ''
          )
          window.location.replace(`${redirectLink}?${combineQueryString}`)
        } else {
          throw new Error('Invalid response: No access token found in response!')
        }
      } catch (error) {
        this.loading = false
        this.error = true
        this.$errorProcessor.capture(error, { errorLocation: 'handleLogin' })
        return error
      }
    },
    sanitizedInput(unsafeStr) {
      return unsafeStr
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;') // '&apos;' is not valid HTML 4
    },
  },
}
</script>

<style lang="scss" scoped>
.signin-page {
  width: 425px;
  min-height: 440px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
  .signin-page__heading {
    justify-content: center;
  }
  &__error-message {
    font-size: 22px;
    font-weight: 800;
    color: #ff8ab1;
    text-align: left;
  }
  button.signin-button {
    background-image: linear-gradient(278deg, #61dffa, $color-bright-sky-blue-two);
    font-weight: bold;
    height: 48px;
  }
  .link-forgot-password {
    color: #c2c2c2;
  }
}
</style>
